import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  height: 70px;
  width: 100%;
  padding: 0 20%;
  background: var(--white);
  border-bottom: 1px solid var(--gray-e);
  position: fixed;
  top: 0;
  z-index: 9;

  > svg {
    height: 20px;
    width: auto;
  }

  @media (max-width: 800px) {
    padding: 0 24px;
  }
`;

export const OfflineBar = styled.div`
  height: 30px;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(20px);
  color: var(--white);
  font-size: 14px;
  position: fixed;
  z-index: 9;
  top: 70px;

  display: flex;
  justify-content: center;
  align-items: center;
`;
